export const Header = () => {
  return (
    <header className="text-center py-20 pt-32">
      <h1 className="text-6xl font-bold text-white mb-4">Task Roulette</h1>
      <p className="text-gray-400 text-lg">
        Smart task selection based on your energy and time. Get the right task for right now.
      </p>
    </header>
  );
};